import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setTreeLoading,
  setTreeDataAndConfig,
  getTreeData,
  cleanUpState,
} from '../scripts/tree-slice';
import GraphButton from '../../GraphButton';

const GetDataBtn = () => {
  const dispatch = useDispatch();
  const treeLoading = useSelector((state) => state.tree.loading);
  const user = useSelector((state) => state.auth.user);

  const onGetData = () => {
    // this is the main state to trigger loading data
    dispatch(setTreeLoading(true));
  };

  const setData = (userData) => {
    // // debug-console.log('setData, length=' + userData);
    // decrypted should be in Text, not Byte, because Thunk will reject
    dispatch(setTreeDataAndConfig(userData));
  };

  useEffect(() => {
    // debug-console.log('[Use Effect] ---------treeLoading=', treeLoading);
    if (treeLoading) {
      // dispatch(cleanUpState);
      try {
        // debug-console.log('Loading: getDBData: user.userId = ' + user.userId);
        // need to set a local function here to call Dispatch
        dispatch(getTreeData({ userId: user.userId, callback: setData }));
      } catch (err) {
        // debug-console.log(err);
        // handel smt
      }
    }
  }, [treeLoading]);

  return (
    <GraphButton
      disabled={user === null}
      id="reloadData"
      label="Tải lại dữ liệu"
      onClick={onGetData}
      title={`Tải lại dữ liệu đã được lưu ${user === null ? '(cần đăng nhập)' : ''}`}
    />
  );
};

export default GetDataBtn;
